import React, { useCallback } from 'react';
import { FlexItem, FlexRow, FlexSpacer } from '@as_core/elements/flexStyles';
import styled from 'styled-components/macro';
import MenuButton from '@components/elements/MenuButton';
import { AddItem } from '@as_core/icons/styledIcons';
import CancelIcon from '@as_core/icons/cancel.icon';
import TrashIcon from '@as_core/icons/trash.icon';
import { TextRegular } from '@as_core/elements/textStyles';
import {
  getFeatureTagIcon,
  getFeatureTagLabel,
  IconsForFeatureTypes,
} from '../ResourceTypeTiles/utils';
import { Tooltip } from '@aseda_library/ui/Tooltip';

const allFeatureTags = Object.keys(IconsForFeatureTypes);

interface PropsI {
  featureTag: string[];
  allowEdit?: boolean;
  updateFeatureTag?: (featureTag: string[]) => void;
}

const debug = false;
const FeatureTagsAddEdit = (props: PropsI) => {
  const {featureTag, allowEdit = false} = props;
  const [editType, setEditType] = React.useState<string>('add');
  const [addFeatureTagOpen, setAddTagFeatureOpen] = React.useState(false);
  if (debug) console.log('FeatureTagAddEdit', featureTag, allowEdit, allFeatureTags);

  const getAddFeatureTags = useCallback(() => {
    if (!addFeatureTagOpen) {
      return (
        <>
          <FlexSpacer width={20}/>
          <MenuButton
            text={'Add New Feature Tag'}
            icon={<AddItem />}
            onClick={() => {setAddTagFeatureOpen(true); setEditType('add')}}
            tooltipPlacement={'bottom'}
          />
          { featureTag.length > 0 && (
            <MenuButton
              text={'Remove a Feature Tag'}
              icon={<TrashIcon />}
              onClick={() => {setAddTagFeatureOpen(true); setEditType('remove')}}
              tooltipPlacement={'bottom'}
            />
          )}
        </>

      );
    }
    return (
      <EditTagContainer v_centered>
        <FlexSpacer width={20}/>
        <TextRegular>{editType}: </TextRegular>
        <FlexSpacer width={5}/>
        {allFeatureTags.map(tag => {
          if (editType === 'add') {
            if (!featureTag.includes(tag)) {
              return (
                <Tooltip
                  key={`add-${tag}`}
                  title={getFeatureTagLabel(tag)}
                >
                  <AddFeatureTag
                    onClick={() => handleAdd(tag)}>
                    { getFeatureTagIcon(tag) }
                  </AddFeatureTag>
                </Tooltip>

              );
            }
          } else {
            if (featureTag.includes(tag)) {
              return (
                <Tooltip
                  key={`remove-${tag}`}
                  title={getFeatureTagLabel(tag)}
                >
                  <RemoveFeatureTag
                    onClick={() => handleDelete(tag)}>
                    { getFeatureTagIcon(tag) }
                  </RemoveFeatureTag>
                </Tooltip>
              );
            }
          }
        })}
        <MenuButton
          text={'Cancel'}
          icon={<CancelIcon />}
          onClick={() => setAddTagFeatureOpen(false)}
          tooltipPlacement={'bottom'}
        />
      </EditTagContainer>

    )
  }, [addFeatureTagOpen])


  const handleAdd = (add_tag: string) => {
    const newFeatureTag = [...featureTag, add_tag];
    props?.updateFeatureTag(newFeatureTag);
    setAddTagFeatureOpen(false);
  }

  const handleDelete = (remove_tag: string) => {
    const newFeatureTag = featureTag.filter((tag) => tag !== remove_tag);
    props?.updateFeatureTag && props.updateFeatureTag(newFeatureTag);
    setAddTagFeatureOpen(false);
  }

  return (
    <FeatureTagsContainer v_centered>
      { featureTag.map((tag) => (
        <Tooltip
          key={`select-${tag}`}
          title={getFeatureTagLabel(tag)}
          arrow
        >
          <FlexItem>
            { getFeatureTagIcon(tag) }
          </FlexItem>
        </Tooltip>
      ))}
      { allowEdit && getAddFeatureTags() }
    </FeatureTagsContainer>
  )
}

export default FeatureTagsAddEdit;

const FeatureTagsContainer = styled(FlexRow)`
  height: 32px;
`

const AddFeatureTag = styled.span<{
  onClick?: () => void;
  children?: React.ReactNode;
}>`
  opacity: 0.5;
  :hover{
      opacity: 1;
      cursor: pointer;
  }
`

const RemoveFeatureTag = styled.span<{
  onClick?: () => void;
  children?: React.ReactNode;
}>`
  opacity: 0.5;
  :hover{
      opacity: 1;
      cursor: not-allowed;
  }
`

const EditTagContainer = styled(FlexRow)`
  border: 1px solid ${(p) => p.theme.palette.accentSecondary};
  border-radius: 10px;
    margin-left: 10px;
`